<app-modal-fp-bulk-upload
  #base
  (closeEmitter)="closeEmitter.emit($event)">
  <div class="table-fms">
    <table>
      <thead>
      <tr>
        <th class="text-left min-width-14">Period</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let fp of base.show.periods">
        <td class="type-text">
          <div class="start-row-container row-gap-0p5">
            <span [attr.data-qa]="'fp-bulk-upload-period-'+fp.name">{{ fp.name }}</span>
            <span *ngIf="fp.isNew" [attr.data-qa]="'fp-bulk-upload-is-new-'+fp.name" class="dot bg-main-8"></span>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</app-modal-fp-bulk-upload>
